module.exports = __webpack_public_path__ + "img/t.142ef1e7.png";